"use client";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { useTranslations } from "next-intl";
import { usePathname, useRouter } from "next/navigation";
import { SearchIcon } from "./searchIcon";

export const SearchField = ({
  searchParams,
  setSearchQuery,
  handleSearch,
  setSearchFieldOpen,
}: any) => {
  const t = useTranslations("SearchField");
  const pathName = usePathname();
  const { replace } = useRouter();
  return (
    <div className="flex items-center justify-between w-full sm:px-8 pl-4 h-[72px] sm:p-0 pr-4">
      <input
        data-testid={applyDataTestId(pom.header.searchInputField)}
        autoFocus
        className="w-full my-4 px-12 py-2 border rounded-lg focus:outline-none focus:ring-1 focus:ring-black text-[16px]"
        defaultValue={searchParams.get("query")?.toString()}
        onChange={(e) => {
          setSearchQuery(e.target.value);
        }}
        onKeyDown={handleSearch}
      />
      <button
        onClick={() => {
          setSearchQuery("");
          setSearchFieldOpen(false);
          const params = new URLSearchParams(searchParams ?? "");
          params.delete("query");
          const otherParams = params.toString();
          replace(otherParams ? `${pathName}?${otherParams}` : pathName);
        }}
        className="absolute right-8 sm:right-16 text-2xl top-1/2 transform -translate-y-[55%] text-black"
        aria-label={t("close")}
      >
        &times;
      </button>
      <div
        className={[
          "absolute",
          "pl-3",
          "sm:pl-5",
          "top-1/2",
          "transform",
          "-translate-y-1/2",
          "text-black",
          "focus:outline-nonecursor-pointer",
        ].join(" ")}
      >
        <SearchIcon />
      </div>
    </div>
  );
};
